import StatisticsItemComponent from '../../../../common/validation-results/StatisticsItemComponent';
import { StatisticsItemType } from '../../../../common/administrationItemsTypes';
import React from 'react';

interface EnabledSkusStatsComponentProps {
  enabledSkusCount: number;
}

/**
 * Shows the number of Skus that will be enabled as part of the import process
 */
const EnabledSkusStatsComponent: React.FC<EnabledSkusStatsComponentProps> = ({
  enabledSkusCount,
}) => {
  return (
    <StatisticsItemComponent
      item={{
        label: 'Skus to be enabled',
        observation: enabledSkusCount,
        type: StatisticsItemType.UNCHANGED,
      }}
    />
  );
};

export default EnabledSkusStatsComponent;
